import React from 'react';

import { RobotInfo } from '@mygpt/app/apis';
import { botStore } from '@mygpt/app/bot/store';
import { BotId } from '@mygpt/types';

export const useBotMethods = () => {
  const setBotId = React.useCallback((id: BotId) => {
    botStore.setState({
      botId: id,
    });
  }, []);

  const clearBot = React.useCallback(() => {
    botStore.setState({
      botId: '',
    });
  }, []);

  const setRobotInfo = React.useCallback((robotInfo: RobotInfo) => {
    botStore.setState({
      robotInfo: robotInfo,
    });
  }, []);

  return {
    setBotId,
    clearBot,
    setRobotInfo,
  };
};
